import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { MessageListTemplate } from 'components/Templates'

const MessageList: FC = () => {
  return (
    <Layout headline={'配信履歴'} iconPath={'/icon/white/message.svg'} title={'配信履歴'}>
      <MessageListTemplate />
    </Layout>
  )
}

export default MessageList
